document.addEventListener("DOMContentLoaded", function() {
  document.getElementById("close-button-ham").addEventListener("click", function() {
    let headerItems = document.querySelector(".header-items.hidden");
    let utilitiesList = document.querySelector(".header__utilities-list.list-menu.hidden");
    let modal = document.querySelector(".header__modal-new-menu.hidden");

    headerItems.classList.remove("hidden");
    utilitiesList.classList.remove("hidden");
    modal.classList.remove("hidden");
  });

  let searchInput = document.getElementById("Search-In-Modal");
  let popularCollections = document.getElementById("popular-collections");

  searchInput.addEventListener("input", function() {
    if (searchInput.value.trim().length > 0) {
      document.querySelector(".header__modal-new-menu").classList.add("hidden");
      document.querySelector(".header-items").classList.add("hidden");
      document.querySelector("ul.header__utilities-list.list-menu").classList.add("hidden");
    } else {
      document.querySelector(".search-promotion-desk-ham").classList.add("ham-custom-show");
    }
  });

  let closeButton = document.querySelector(".icon-close");
  if (closeButton) {
      closeButton.addEventListener("click", function() {
          popularCollections.style.display = "block";
      });
  }

  let headerMenuClickCustom = document.getElementById('HeaderMenuClickCustom');
  let headerNewNavSearch = document.querySelector('.header-new-nav-search');
  let hamBarNavSearch = document.querySelector('.header-new input.search__input.search__input_ham');
  let newHeaderSearchBar = document.querySelector('.header-new-nav-search input.search__input.field__input.newly.added.custom-input-field');
  let newHeaderSearchPromotionGrid = document.querySelector('.search-promotion-desk-grid');
  let newHeaderSearchClose = document.querySelector('.reset__button-header-new');
  let newHeaderSearchBarOverlay = document.querySelector('.header-new-nav-search .header-new-modal-overlay');

  if (headerMenuClickCustom && headerNewNavSearch) {
    headerMenuClickCustom.addEventListener('click', function() {
      if(headerNewNavSearch.classList.contains('appear-on-icon-click')) {
        headerNewNavSearch.classList.add('hide-header-new-nav-search','hidden');
        document.querySelector('.main-nav-search-icon').classList.add('shows-main-nav-search-icon');
        document.querySelector('header.header .container.container--custom-style').classList.remove('show--header-style');
      } else {
        headerNewNavSearch.classList.add('hide-header-new-nav-search');
      }
      newHeaderSearchBar.value = '';
      newHeaderSearchPromotionGrid.classList.remove('show-search-promotion-desk-grid');
      newHeaderSearchBarOverlay.classList.remove('header-new--overlay');
      newHeaderSearchClose.classList.add('hidden');
      let inputEvent = new Event('input', { bubbles: true, cancelable: true,});
      newHeaderSearchBar.dispatchEvent(inputEvent);
      // hamBarNavSearch.dispatchEvent(new Event('blur', { bubbles: true, cancelable: true,}));
      hamBarNavSearch.setAttribute('disabled','');
      setTimeout(() => {
        hamBarNavSearch.dispatchEvent(new Event('blur', { bubbles: true, cancelable: true,}));
        hamBarNavSearch.removeAttribute('disabled');
      },100);
    });
  }

  let modalCloseButton = document.querySelector('.modal__close-button');
  if (modalCloseButton && headerNewNavSearch) {
    modalCloseButton.addEventListener('click', function() {
      headerNewNavSearch.classList.remove('hide-header-new-nav-search');
    });
  }

  let searchInputCustom = document.querySelector('.custom-input-field');
  let searchInputBackButton = document.querySelector('.reset__button-header-new');
  if (searchInputCustom) {
    document.addEventListener('click', function(event) {
      if (event.target === searchInputCustom) {
        let searchCollectionGrid = document.querySelector('.search-promotion-desk-grid');
        let searchPromotionDeskGrid = document.querySelector('.inner-search-promotion-desk-grid');
        if (searchCollectionGrid) {
          if(!searchInputCustom.value.trim().length > 0){
            searchCollectionGrid.classList.add('show-search-promotion-desk-grid');
          }else{
            searchCollectionGrid.classList.remove('show-search-promotion-desk-grid');
          }
          searchInputBackButton.classList.remove('hidden'); // show close button
          searchPromotionDeskGrid.classList.remove("hidden");
          document.body.classList.add('overflow-hidden'); // add overflow hidden on body
        }
        let searchCollectionGridOverlay = document.querySelector('.header-new-modal-overlay');
        if (searchCollectionGridOverlay) {
          searchCollectionGridOverlay.classList.add('header-new--overlay');
        }
      }
    });
  }

  let headerNewModalOverlay = document.querySelector('.header-new-modal-overlay');
  let headerNewSeachBarElement = document.querySelector('.header-new-nav-search');
  if (headerNewModalOverlay) {
    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('header-new-modal-overlay') && event.target.classList.contains('header-new--overlay')) {
        let searchPromotionDeskGrid = document.querySelectorAll('.search-promotion-desk-grid.show-search-promotion-desk-grid');
        searchPromotionDeskGrid.forEach(function(element) {
          element.classList.remove('show-search-promotion-desk-grid');
          searchInputBackButton.classList.add('hidden'); // hide close button
        });
        event.target.classList.remove('header-new--overlay');
        document.querySelector('.header-new-nav-search .search__input.field__input.custom-input-field').value = '';
        document.querySelector('.header-new-nav-search predictive-search').removeAttribute('result');
        document.querySelector('.header-new-nav-search predictive-search').removeAttribute('open');
        document.body.classList.remove('overflow-hidden'); // remove overflow hidden from body
        if(headerNewSeachBarElement.classList.contains('appear-on-icon-click')) {
          headerNewSeachBarElement.classList.add('hides-header-new-nav-search','hidden');
          document.querySelector('.header .container.container--custom-style').classList.remove('show--header-style');
          document.querySelector('.main-nav-search-icon').classList.add('shows-main-nav-search-icon');
        }
      }

      if (event.target.classList.contains('icon') && event.target.classList.contains('icon-close')) {
        let headerNewModalOverlay = document.querySelector('.header-new-modal-overlay.header-new--overlay');
        if (headerNewModalOverlay) {
          headerNewModalOverlay.classList.remove('header-new--overlay');
          document.body.classList.remove('overflow-hidden'); // remove overflow hidden from body
        }
        let searchPromotionDeskGrid = document.querySelectorAll('.search-promotion-desk-grid.show-search-promotion-desk-grid');
        searchPromotionDeskGrid.forEach(function(element) {
          element.classList.remove('show-search-promotion-desk-grid');
        });
      }
    });
  }

  document.querySelector(".search__input_ham").addEventListener("click", function() {
    document.querySelector(".search-promotion-desk-ham").classList.add("ham-custom-show");
    document.querySelector(".header__modal-new-menu").classList.add("hidden");
    document.querySelector(".header-items").classList.add("hidden");
    document.querySelector("ul.header__utilities-list.list-menu").classList.add("hidden");
    document.querySelector('.header-new button.reset__button-new').classList.add('show-close_btn'); // hide close button
  });

  const closeButtonCustom = document.querySelector('.icon-close');
  closeButtonCustom.addEventListener('click', function() {
    document.querySelector('.header__modal-new-menu').classList.remove('hidden');
    document.querySelector('.header-items').classList.remove('hidden');
    document.querySelector('ul.header__utilities-list.list-menu').classList.remove('hidden');
  });

  document.querySelector(".icon.icon-close").addEventListener("click", function() {
    document.querySelector(".header__modal-new-menu").classList.remove("hidden");
    document.querySelector(".header-items").classList.remove("hidden");
    document.querySelector("ul.header__utilities-list.list-menu").classList.remove("hidden");
    document.querySelector(".search-promotion-desk-ham").classList.remove("ham-custom-show");
  });

  document.querySelector(".modal-overlay").addEventListener("click", function() {
    document.querySelector(".header__modal-new-menu").classList.remove("hidden");
    document.querySelector(".header-items").classList.remove("hidden");
    document.querySelector("ul.header__utilities-list.list-menu").classList.remove("hidden");
    document.querySelector(".search-promotion-desk-ham").classList.remove("ham-custom-show");
  });

  // actions performed when hamburger close button is clicked
  document.querySelector("button.modal__close-button.link.link--text.focus-inset.header__modal-button.small-hide").addEventListener("click", function() {
    document.querySelector(".header__modal-new-menu").classList.remove("hidden"); // make ham menu visible
    document.querySelector(".header-items").classList.remove("hidden"); // make collection with images visible
    document.querySelector("ul.header__utilities-list.list-menu").classList.remove("hidden"); // make utility links visible
    document.querySelector(".search-promotion-desk-ham").classList.remove("ham-custom-show"); // hide trending searches
    document.querySelector('.header-new .reset__button-new').classList.remove('show-close_btn'); // hide close button on ham search
  });

  let searchInputNew = document.querySelector(".search__input.field__input.newly.added.custom-input-field");
  if (searchInputNew) {
    searchInputNew.addEventListener("input", function() {
      if (searchInputNew.value.trim().length > 0) {

        popularCollections.classList.add("hidden");
      } else {

        popularCollections.classList.remove("hidden");
      }
    });
  }

  let searchInputCustomField = document.querySelector('.custom-input-field');
  let searchPromotionDeskGrid = document.querySelector('.inner-search-promotion-desk-grid');

  if (searchInputCustomField && searchPromotionDeskGrid) {
    searchInputCustomField.addEventListener('input', function() {
      const inputValue = this.value.trim();

      if (inputValue.length > 0) {
        searchPromotionDeskGrid.classList.add("hidden");
      } else {
        searchPromotionDeskGrid.classList.remove("hidden");
      }
    });
  }

  let scrollableElement = document.querySelector('.header__modal-inner');

  if (scrollableElement) {
    scrollableElement.addEventListener("scroll", function() {
      let scrollPosition = scrollableElement.scrollTop;

      if (scrollPosition > 30 ) {
        document.querySelector('.js-false-search').classList.add('search-ham-scroll-show-icon');
      } else {
        document.querySelector('.js-false-search').classList.remove('search-ham-scroll-show-icon');
      }
    });
  }

  let lastScrollTop = 0;
  window.addEventListener('scroll', function() {
    let scrollPosition = window.scrollY;
    let customInput = document.querySelector('.header-new-nav-search');
    if (scrollPosition > lastScrollTop) {
      customInput.classList.add('hides-header-new-nav-search');
    } else {
      customInput.classList.remove('hides-header-new-nav-search');
    }
    lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition; // For Mobile or negative scrolling
  });

  let searchIcon = document.querySelector('.main-nav-search-icon');
  if (searchIcon) {
    let customInput = document.querySelector('.header-new-nav-search');
    searchIcon.addEventListener('click', function(e) {
      if(e.target.closest('li').classList.contains('linked_search_bar_hidden')) {
        customInput.classList.remove('hides-header-new-nav-search','hidden');
        searchIcon.classList.remove('shows-main-nav-search-icon');
        searchPromotionDeskGrid.classList.add('show-search-promotion-desk-grid');
        headerNewModalOverlay.classList.add('header-new--overlay');
        document.querySelector('.header .container.container--custom-style').classList.add('show--header-style');
      } else {
        searchIcon.classList.remove('shows-main-nav-search-icon');
        searchPromotionDeskGrid.classList.add('show-search-promotion-desk-grid');
        headerNewModalOverlay.classList.add('header-new--overlay');
      }
    });
  }

  window.addEventListener('scroll', function() {
    let scrollPosition = window.scrollY;
    let customInput = document.querySelector('.header-new-nav-search');
    let searchIcon = document.querySelector('.main-nav-search-icon');

    if (scrollPosition >= 10) {
      customInput.classList.add('hides-header-new-nav-search');
      searchIcon.classList.add('shows-main-nav-search-icon');
    } else {
      customInput.classList.remove('hides-header-new-nav-search');
      let searchIconListItem = searchIcon.closest('li');
      if(!searchIconListItem.classList.contains('linked_search_bar_hidden')) {
        searchIcon.classList.remove('shows-main-nav-search-icon');
      } else {
        if(this.document.querySelector('.header-new-modal-overlay').classList.contains('header-new--overlay')){
          searchIcon.classList.remove('shows-main-nav-search-icon');
        }
      }
    }

    let documentHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );

    if ((scrollPosition + window.innerHeight) >= documentHeight) {
      customInput.classList.remove('hides-header-new-nav-search');
      searchIcon.classList.remove('shows-main-nav-search-icon');
    }
  });

  let modalOverlay = document.querySelector('.modal-overlay');
  if (modalOverlay) {
    modalOverlay.addEventListener('click', function() {
      headerNewNavSearch.classList.remove('hide-header-new-nav-search');
    });
  }

  let popularCollectionsHam = document.querySelector('.header-new #popular-collections');
  let searchInputHam = document.querySelector("input.search__input.field__input.newly.added.search__input_ham");
  if (searchInputHam) {
    searchInputHam.addEventListener("input", function() {
      if (searchInputHam.value.trim().length > 0) {
        popularCollectionsHam.classList.add("hidden");
      } else {
        popularCollectionsHam.classList.remove("hidden");
      }
    });
  }

  searchInputHam.addEventListener('focus',(evt) => {
    if(evt.target.value.trim().length > 0){
      popularCollectionsHam.classList.add("hidden");
    }else{
      popularCollectionsHam.classList.remove("hidden");
    }
  });


  document.getElementById('modal__close-button_custom').addEventListener('click', function() {
    document.querySelector('.search-promotion-desk-ham').classList.remove('ham-custom-show');
    document.querySelector('.header-new .reset__button-new').classList.remove('show-close_btn'); // hide close button
    setTimeout(() => {
      document.querySelector('.search-promotion-desk-ham').classList.remove('ham-custom-show');
      document.querySelector('.header-new #popular-collections').classList.add('hidden');
      document.body.classList.remove('overflow-hidden'); // remove overflow hidden from body
      document.querySelector('.header-new .reset__button-new').classList.remove('show-close_btn'); // hide close button
      if(document.querySelector('.linked_search_bar_hidden')){
        document.querySelector('.main-nav-search-icon').classList.add('shows-main-nav-search-icon');
        document.querySelector('header.header .container.container--custom-style').classList.remove('show--header-style');
      }
    },110);
  });


  let modalCloseBtn = document.getElementById("modal__close-button_custom");
  let hamCloseButton = document.getElementById("close-button-ham");

  modalCloseBtn.addEventListener("click", function() {
    hamCloseButton.click();
    document.querySelector('.header-new .reset__button-new').classList.remove('show-close_btn'); // hide close button
  });

  const headerSearchResetButton = document.querySelector('.reset__button-header-new');
  const headerSearchPromotions = document.querySelector('.search-promotion-desk-grid');
  const headerSearchPromoOverlay = document.querySelector('.header-new-modal-overlay');
  const headerSearchInputField = document.querySelector('.header-new-nav-search .search__input.field__input.custom-input-field');
  const headerSearchPredictiveSearch = document.querySelector('.header-new-nav-search predictive-search');
  const headerSearchBarWithPredictiveSearch = document.querySelector('.header-new-nav-search');
  const headerSearchIconListItem = document.querySelector('.linked_search_bar_hidden');

  headerSearchResetButton.addEventListener('click', () => {
    if(headerSearchIconListItem) {
      headerSearchBarWithPredictiveSearch.classList.add('hides-header-new-nav-search','hidden');
      document.querySelector('.header .container.container--custom-style').classList.remove('show--header-style');
      document.querySelector('.main-nav-search-icon').classList.add('shows-main-nav-search-icon');
    }
    headerSearchPromotions.classList.remove('show-search-promotion-desk-grid');
    headerSearchPromoOverlay.classList.remove('header-new--overlay');
    headerSearchResetButton.classList.add('hidden');
    headerSearchInputField.value = '';
    headerSearchPredictiveSearch.removeAttribute('result');
    headerSearchPredictiveSearch.removeAttribute('open');
    document.body.classList.remove('overflow-hidden'); // remove overflow hidden from body
  });

  // actions performed on click of ham search close button
  const resetBtnNew = document.querySelector('.header-new .reset__button-new');
  const hamMenu = document.querySelector('.header__modal-new-menu');
  const hamMenuItems = document.querySelector('.header-items');
  const hamMenuUtilities = document.querySelector('ul.header__utilities-list.list-menu');
  const hamSearch = document.querySelector('.header-new predictive-search input.search__input');
  const hamPopularWrapper = document.querySelector('.header-new .search-promotion-desk-ham');
  const hamPopularCollection = document.querySelector('.header-new #popular-collections');
  const hamPredictiveSearch = document.querySelector('.header-new predictive-search');

  resetBtnNew.addEventListener('click', (e) => {
    e.preventDefault();
    hamSearch.value = ''; // clear search input value
    hamMenu.classList.remove('hidden'); // make ham menu visible
    hamMenuItems.classList.remove('hidden'); // make ham collection with images visible
    hamMenuUtilities.classList.remove('hidden'); // make utility links visible on ham
    hamPopularWrapper.classList.remove('ham-custom-show'); // hide searches
    hamPopularCollection.classList.add('hidden'); // hide popular collection
    hamPredictiveSearch.removeAttribute('results'); // remove results attribute from predictive-search
    hamPredictiveSearch.removeAttribute('open'); // remove open attribute from predictive-search
    resetBtnNew.classList.remove('show-close_btn'); // hide close button
  });

  function checkShippingBarVisibility() {
    let shippBar = document.querySelector('shipping-bar.shipping-bar');
    let siteHeaderBar = document.querySelector('.header-wrapper');
    if(!shippBar || !siteHeaderBar) return;
    if(!shippBar.classList.contains('international-hide') && !shippBar.classList.contains('us-hide')) {
      if(siteHeaderBar.classList.contains('header-wrapper--only-white') && siteHeaderBar.classList.contains('full-width-header') || siteHeaderBar.classList.contains('header-wrapper--transparent-white') ) {
        shippBar.classList.add('is-visible-onsite');
      }
    }
  }
  checkShippingBarVisibility();
});
